import { API_URL_ARTIST } from "@constants/env";
import { ArtistVerified } from "@enums/artistVerified";
import apiInstance from "@services/Shared/instanceAxios";

const verifyArtist = (uuid: string, newVerified: ArtistVerified) =>
  apiInstance({
    url: `${API_URL_ARTIST}${uuid}/verified`,
    method: "put",
    data: { verified: newVerified },
  });

export default verifyArtist;
